<script lang="ts">
    import { createEventDispatcher } from 'svelte';
    import type { TopNDefinition } from 'header/types';

    interface Props {
        field: TopNDefinition;
    }

    let { field }: Props = $props();

    const dispatch = createEventDispatcher();

    const onSelect = (e: { currentTarget: HTMLSelectElement }) => {
        dispatch('change', {
            field: {
                ...field,
                value: Number(e.currentTarget.value),
            },
        });
    };
    const onInput = (e: { currentTarget: HTMLInputElement }) => {
        dispatch('change', {
            field: {
                ...field,
                value: e.currentTarget.value,
            },
        });
    };
</script>

<div class="field">
    <select
        class="select"
        disabled={field.changeable === false}
        value={field.select.value}
        oninput={onSelect}
    >
        {#each field.select.options as { key, label } (key)}
            <option value={key}>{label}</option>
        {/each}
    </select>
    <input
        class="input"
        type="number"
        disabled={field.changeable === false}
        value={field.value}
        oninput={onInput}
    />
</div>

<style lang="scss" scoped>
    .field {
        overflow-x: auto;
        display: flex;
        align-items: stretch;
        column-gap: 0.5rem;
        font-size: 0.8rem;
    }
    .select,
    .input {
        overflow: hidden;
    }
    .select {
        width: 50%;
    }
    .input {
        width: 50%;
    }
</style>
